<template>
  <div class="stages-item" data-stage="data.name">

      <div class="heading">
          <p> {{ $ml.get(data.name) }} </p>
        <MoreActions
          v-if="$store.getters['crop/base'].owner != 0"
          @remove="$emit('remove')"
          @edit="$emit('edit')"
        />
      </div>

      <!-- TODO: add height transition -->
      <div class="stripe">
        <div class="left">
          <div class="col duration" v-if="duration.value">
              <div class="label">
                {{$ml.get(`AVG. DURATION`)}}
              </div>
              <div class="value">
                {{ duration.value }} {{ $ml.get('days') }}
              </div>
          </div>
          <!-- <div class="col total">
            <div class="label">
              {{$ml.get(`TOTAL N`)}}
            </div>
            <div class="value">
              {{ totalN.value }}
            </div>
          </div> -->
        </div>
        <!-- <pre>
          {{data.data}}
        </pre> -->
        <div class="nutrients">

          <div class="col nutrient" v-if="pH.hasOwnProperty('value') && pH.value">
            <div class="label">
              pH
            </div>
            <div class="value">
              {{ pH.value }}
            </div>
          </div>

          <div class="col nutrient" v-for="nutrient in outputNutrients">
            <div class="label">
              {{ nutrient.label }}
            </div>
            <div class="value">
              {{
                ($store.getters['crop/base'].type == 'soil-grown' && unit == $store.getters['unit/getLabel']('kg/ha')) ?
                $store.getters['unit/convert']('kg/ha', nutrient.value) :
                ($store.getters['crop/base'].type == 'soil-grown' && unit == 'ppm') ?
                getValue(nutrient) :
                $store.getters['unit/convert']('kg/ha', nutrient.value)
              }}
            </div>
          </div>
        </div>

        <!-- <button
          @click="$emit('edit')"
          class="h-btn h-empty-btn edit-btn"
          v-if="$store.getters['crop/base'].owner != 0"
        >
          <EditSVG/>
        </button> -->

      </div>
    <!-- </DropList> -->
  </div>
</template>

<script>
import DropList from '@/components/common/DropList';
import EditSVG from './icons/EditSVG';
import MoreActions from './MoreActions';
import { UnitConverter } from '@/mixins/unit-converter.mixin';

export default {
  mixins: [UnitConverter],
  components: {
    DropList,
    EditSVG,
    MoreActions
  },

  props: {
    data: {},
    unit: {}
  },

  data() {
    return {

    }
  },

  methods: {
    getValue(nutrient) {
      return this.toPpm(nutrient.label, 'Kg/ha', nutrient.value).toFixed(2)
    }
  },

  computed: {
    duration() {
      return this.data.data.find(n => n.key == 'duration');
    },

    totalN() {
      return this.data.data.find(n => n.key == 'gdd');
    },

    pH() {
      if( this.data.data.find(n => n.key == 'ph') ) {
        return this.data.data.find(n => n.key == 'ph')
      } else {
        return {};
      }

    },

    outputNutrients() {
      console.log(this.data.data)
      return this.data.data.filter(n => {
        if (n.is_nutrient && n.value) {
          if(typeof(n.value) == 'string' && n.value.includes(','))
            n.value = n.value.replace(',', '.')
          if(n.label != 'HCO3' && n.label != 'Na' && n.label != 'Cl' && n.label != 'Al') {
            return n;
          }
          // console.log(n.label);
          // return n;

        }
      });
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .more-actions {

    margin: 20px 0;
    align-self: flex-start;

    svg circle {
      fill: $mainGreen;
    }
  }
}

.stages-item {
  .heading {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-top: 24px;
    p {
      font-weight: bold;
    }
  }
  .stripe {
    width: 100%;
    border-bottom: 1px solid #E4E5E6;
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: stretch;
    .col {
      display: flex;
      flex-direction: column;
      align-items: stretch;
      padding: 15px;
      .label {
        color: rgb(111, 156, 64);
        letter-spacing: 0.05em;
        font-size: 12px;
      }
      .value {
        padding-top: 3px;
        color: #4C5056;
        font-size: 16px;
      }
    }
    .left {
      display: flex;
      flex-direction: row;
      align-items: stretch;
      // width: 200px;
      // border-right: 1px solid #E4E5E6;
      .col {
        flex-grow: 1;
        &:first-child {
          padding-left: 0;
        }
      }
    }
    .nutrients {
      // width: calc(100% - 200px);
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      flex-grow: 1;

      .scroller {
        height: 100%;
      }
    }
    .edit-btn {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 20px;
      height: 20px;
      border-radius: 50%;
    }

  }
  @media(max-width:768px) {
    .heading {
      margin-top: 8px;
    }
    .stripe {
      display: flex;
      flex-direction: column;
      .nutrients {
        margin-right: -8px;
        margin-left: -8px;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-start;
        .col {
          padding: 16px 12px;
          // margin-right: 16px;
          // margin-left: 16px;
          flex-basis: calc(33.3%);
        }
      }
      .left {
        width: 100%;
        .col {
          padding: 16px 0;
          &.duration {
            padding-right: 8px;
          }
        }
      }
      .nutrients, .h-btn {
        // display: none;
      }
    }
  }
}
body[dir="rtl"] {
  .stages-item {
    .stripe {
      .left {
        .col {
          &:first-child {
            padding-right: 0;
            padding-left: 15px;
          }
        }
      }
    }
  }
}
</style>
